import styled from 'styled-components';

export const UsageAttitudeStyles = styled.div`
  font-family: 'Montserrat';
  position: relative;
  overflow: hidden;

  .container {
    max-width: 1190px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0 10px;
    margin: 0 auto;
    position: relative;

    @media (max-width: 991px) {
      flex-direction: column;
      gap: 15px;
    }

    h5 {
      font-weight: 700;
      font-size: 18px;
      line-height: 120%;
      background: var(
        --Gradient-Check-Audit,
        linear-gradient(135.55deg, #5498ff 0%, #7e6de4 100.95%)
      );
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    .content {
      max-width: 770px;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 25px;
    }
  }

  .btn-container {
    display: flex;
    width: 100%;
    margin-top: 50px;
    justify-content: center;
  }
`;
